import PropTypes from 'prop-types';
import React from 'react';

/* eslint-disable react/no-danger */

export const StructuredData = ({ title, image }) => {
  const data = {
    '@context': 'https://schema.org',
    '@type': 'NewsArticle',
    headline: title,
    image: [image],
    publisher: {
      '@type': 'Organization',
      name: 'BNNVARA',
      logo: {
        '@type': 'ImageObject',
        url: 'https://bnnvara.nl/static/favicon/favicon-32x32.png',
      },
    },
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: JSON.stringify(data),
      }}
    />
  );
};

StructuredData.propTypes = {
  title: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
};
